import { render, staticRenderFns } from "./SearchAndAddBox.vue?vue&type=template&id=37324103&scoped=true&"
import script from "./SearchAndAddBox.vue?vue&type=script&lang=ts&"
export * from "./SearchAndAddBox.vue?vue&type=script&lang=ts&"
import style0 from "./SearchAndAddBox.vue?vue&type=style&index=0&id=37324103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37324103",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
